import {I18n} from "i18n-js";

delete Date.prototype['_nth'] // because of https://github.com/elm/core/issues/1005

window.I18n = new I18n();